/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const manage = {
  path: '/manage',
  component: Layout,
  redirect: '/manage/project-info',
  name: 'Manage',
  meta: {
    title: 'manage',
    icon: 'zuzhiqunzu',
    perm: 'cSiteProjectManager'
  },
  children: [
    {
      path: 'project-info',
      component: () => import('@/views/manage/project-info/index.vue'),
      name: 'ProjectInfo',
      meta: { title: 'projectInfo', perm: 'cSiteProjectInfo' }
    },
    {
      path: 'contractor',
      component: () => import('@/views/manage/contractor/contractor.vue'),
      name: 'Contractor',
      meta: { title: 'contractor', perm: 'cSiteProjectCompanyManager' }
    },
    {
      path: 'team-management',
      component: () => import('@/views/manage/team-management/index.vue'),
      name: 'TeamManagement',
      meta: { title: 'teamManagement', perm: 'cSiteTeamManager' }
    },
    {
      path: 'work-type-info',
      component: () => import('@/views/manage/work-type/workType.vue'),
      name: 'WorkTypeInfo',
      meta: {
        title: 'workTypeInfo',
        perm: 'cWorkerTypeManager',
        dictionaryTypeCode: 'workerType'
      }
    },
    {
      path: 'job-type-info',
      component: () => import('@/views/manage/work-type/workType.vue'),
      name: 'JobTypeInfo',
      meta: {
        title: 'jobTypeInfo',
        perm: 'cWorkerTypeManager',
        dictionaryTypeCode: 'managerType'
      }
    },
    {
      path: 'district-management',
      component: () => import('@/views/manage/district-management/index.vue'),
      name: 'DistrictManagement',
      meta: { title: 'districtManagement', perm: 'cSiteAreaManager' }
    },
    {
      path: 'wechat-app',
      component: () => import('@/views/manage/wechat-app/index.vue'),
      name: 'WechatApp',
      meta: { title: 'wechatApp', perm: 'cSiteAreaManager' }
    },
    {
      path: 'rule-setting',
      component: () => import('@/views/manage/rule-setting/index.vue'),
      name: 'RuleSetting',
      meta: { title: 'ruleSetting', perm: 'siteProjectTrainRule' }
      //    perm: 'siteProjectTrainRule'
    }
  ]
}
export default manage
